import { call, fork, put, take } from 'redux-saga/effects';
import {Api} from '../api';
import {Depot} from '../api/types';
import {fetchDepots} from '../action/depotsCommands';
import {depotsFetched} from '../action/depotsEvents';
import {enqueueErrorSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import Logger from '../common/logger';

export const onFetchDepots = function*() {
    try {
        const depots: Depot[] = yield call(Api.getDepots);
        yield put(depotsFetched({ depots }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({ message: getI18n().t('snackbar.error.fetch_depots') }));
    }
};

export function* fetchDepotsFlow() {
    while (true) {
        yield take(fetchDepots.toString());

        yield fork(onFetchDepots);
    }
}
